import React, { forwardRef } from 'react';
import bem from 'utils/bem';
import Model from '../../../../model';
import DatetimeField from '../DatetimeField';
import TicketDateTimeInput, { TicketDateTimeInputSkeleton } from './TicketDateTimeInput';
import { observer } from 'mobx-react-lite';
import './index.sass';
import MobileDialogDateTimeField from 'forms/fields/DatetimeField/MobileDialogDateTimeField';
import PopoverDateTimeField from 'forms/fields/DatetimeField/PopoverDateTimeField';
import { useMobile } from 'utils/media';

const { block, el } = bem('tickets-field');

const MobilePopup = (props) => {
    const text = 'Выберите желаемую\nдату и время';
    return <MobileDialogDateTimeField { ...props } text={ text }/>
}

const TicketsField = (props) => {

    const { isMobile } = useMobile();
    const { events, selectedEvents, setSelectedEvents } = props;

    const setExtValue = (index) => (value) => {
        setSelectedEvents(index, value);
    };

    const TicketDateTimeInputWithNumber = (i) => {
        return forwardRef((props, ref) => <TicketDateTimeInput number={ i } { ...props } ref={ ref }/>);
    };

    return (
        <div className={ block() }>
            { selectedEvents.map((selectedEvent, i) =>
                <DatetimeField key={ i }
                               className={ el('datetime') }
                               name={ 'ticket-field' }
                               Input={ TicketDateTimeInputWithNumber(i + 1) }
                               utcDates={ events }
                               setValue={ setExtValue(i) }
                               value={ selectedEvent ? selectedEvent : null }
                               Popup={ isMobile ? MobilePopup : PopoverDateTimeField }
                               selected={ selectedEvents.filter(e => e !== selectedEvent) }/>
            ) }
        </div>
    );
};

export const TicketsFieldSkeleton = () => {
    return (
        <div className={block()}>
            <TicketDateTimeInputSkeleton />
        </div>
    )
}

export default observer(TicketsField);
